/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum BankAccountStatus {
    DRAFT = 'DRAFT',
    PENDING_VERIFICATION = 'PENDING_VERIFICATION',
    PENDING_ADMIN_REVIEW = 'PENDING_ADMIN_REVIEW',
    APPROVED = 'APPROVED',
    REJECTED = 'REJECTED',
    INACTIVE = 'INACTIVE',
    INVESTOR_OTP_REQUESTED = 'INVESTOR_OTP_REQUESTED',
    INVESTOR_OTP_SUCCEEDED = 'INVESTOR_OTP_SUCCEEDED',
    INVESTOR_OTP_FAILED = 'INVESTOR_OTP_FAILED',
}
